import React from "react";

const BenefitsSpeedIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0453 2.93177C15.1483 1.04483 12.6386 0 9.98048 0C7.32631 0 4.82436 1.04873 2.9313 2.93567C1.04215 4.82261 0 7.33333 0 9.98441C0 12.6394 1.03825 15.1462 2.9274 17.0448C4.82436 18.9474 7.32631 20 9.98048 20C11.3232 20 12.6269 19.7271 13.8642 19.2008C15.0546 18.694 16.1241 17.961 17.0492 17.0409C17.9742 16.1209 18.6963 15.0487 19.2037 13.8596C19.7307 12.6238 20 11.3177 20 9.98051C20 7.32554 18.95 4.82261 17.0453 2.93177ZM15.9446 15.9376C14.3365 17.5439 12.2209 18.4289 9.98048 18.4289C5.33958 18.4289 1.56128 14.6394 1.56128 9.98051C1.56128 7.74659 2.4395 5.63743 4.03591 4.04288C5.63232 2.44834 7.74005 1.57115 9.98048 1.57115C14.6448 1.57115 18.4387 5.34113 18.4387 9.98051C18.4387 12.2144 17.5527 14.3314 15.9446 15.9376Z"
      fill="#5B5A54"
    />
    <path
      d="M10.4997 11.8404L13.4789 15.2252C13.7489 15.5319 14.2212 15.562 14.5287 15.292C14.8361 15.0221 14.8668 14.5503 14.5968 14.2436L11.6274 10.8699C12.0204 10.1343 11.9411 9.20544 11.3595 8.54465C10.6111 7.69427 9.3069 7.60865 8.4517 8.35962C7.5965 9.11058 7.512 10.4107 8.26294 11.2638C8.83473 11.9135 9.72833 12.1125 10.4997 11.8404ZM9.43332 9.47487C9.67087 9.26627 10.033 9.28931 10.2416 9.5263C10.4502 9.7633 10.4267 10.125 10.1892 10.3336C9.95161 10.5422 9.58944 10.5192 9.38085 10.2822C9.17225 10.0452 9.19576 9.68347 9.43332 9.47487Z"
      fill="#5B5A54"
    />
    <path
      d="M4.01639 9H2.98361C2.44262 9 2 9.45 2 10C2 10.55 2.44262 11 2.98361 11H4.01639C4.55738 11 5 10.55 5 10C5 9.45 4.55738 9 4.01639 9Z"
      fill="#5B5A54"
    />
    <path
      d="M14.9836 9C14.4426 9 14 9.45 14 10C14 10.55 14.4426 11 14.9836 11H16.0164C16.5574 11 17 10.55 17 10C17 9.45 16.5574 9 16.0164 9H14.9836Z"
      fill="#5B5A54"
    />
    <path
      d="M9 5.01639C9 5.55738 9.45 6 10 6C10.55 6 11 5.55738 11 5.01639L11 3.98361C11 3.44262 10.55 3 10 3C9.45 3 9 3.44262 9 3.98361L9 5.01639Z"
      fill="#5B5A54"
    />
    <path
      d="M14.7293 5.16489C14.4114 4.91239 13.9402 4.95507 13.6746 5.25736L13.1734 5.8335C12.9079 6.13579 12.9527 6.5839 13.2707 6.83641C13.409 6.94665 13.5811 7 13.7494 7C13.9626 7 14.1795 6.91109 14.3254 6.74394L14.8266 6.1678C15.0921 5.86551 15.0473 5.4174 14.7293 5.16489Z"
      fill="#5B5A54"
    />
    <path
      d="M6.3254 5.25736C6.05984 4.95507 5.58858 4.91239 5.27066 5.16489C4.95274 5.4174 4.90786 5.86551 5.17342 6.1678L5.6746 6.74394C5.82421 6.91465 6.0374 7 6.25059 7C6.4189 7 6.58721 6.94665 6.72934 6.83641C7.04726 6.5839 7.09214 6.13579 6.82658 5.8335L6.3254 5.25736Z"
      fill="#5B5A54"
    />
  </svg>
);

export default BenefitsSpeedIcon;
